import { Fragment } from "react";
import { Input } from "reactstrap";

export const getInvoicesColumns = (handleSelectAllTrips, isAllChecked) => [
    {
        name: (
            <input
                type="checkbox"
                checked={isAllChecked}
                onChange={(value) => handleSelectAllTrips(value)}
            />
        ),
        cell: (row) => row["action"],
        center: true,
        style: {
            minWidth: "30px"
        }
    },
    {
        name: "BOOKING #",
        selector: (row) => row["megaCabsBookingNo"],
        sortable: true,
        center: true,
    },
    {
        name: (
            <span>
                <Fragment>
                    PICKUP <i className="fa fa-map-marker"></i>
                </Fragment>
            </span>
        ),
        selector: (row) => row["pickUpAddress"],
        sortable: true,
        center: true,
    },
    {
        name: (
            <span>
                <Fragment>
                    DROP <i className="fa fa-map-marker"></i>
                </Fragment>
            </span>
        ),
        selector: (row) => row["destAddress"],
        sortable: true,
        center: true,
    },
    {
        name: "TOTAL DISTANCE",
        selector: (row) => row["totalDistanceInKm"],
        sortable: true,
        center: true,
    },
    {
        name: "TOTAL FARE",
        selector: (row) => row["totalFare"],
        sortable: true,
        center: true,
    },
    {
        name: (
            <span>
                <Fragment>
                    UPDATED PICKUP <i className="fa fa-map-marker"></i>
                </Fragment>
            </span>
        ),
        selector: (row) => row["updatedPickUpAddress"],
        sortable: true,
        center: true,
    },
    {
        name: (
            <span>
                <Fragment>
                    UPDATED DROP <i className="fa fa-map-marker"></i>
                </Fragment>
            </span>
        ),
        selector: (row) => row["updatedDestAddress"],
        sortable: true,
        center: true,
    },
    {
        name: "UPDATED TOTAL DISTANCE",
        selector: (row) => row["updatedTotalDistanceInKm"],
        sortable: true,
        center: true,
    },
    {
        name: "UPDATED TOTAL FARE",
        selector: (row) => row["updatedTotalFare"],
        sortable: true,
        center: true,
    },
    {
        name: "STATUS",
        cell: (row) => row["status"],
        sortable: true,
        center: true,
    },
];